import enLocale from 'element-plus/es/locale/lang/en'
import esLocale from 'element-plus/es/locale/lang/es'
import frLocale from 'element-plus/es/locale/lang/fr'
import { createI18n } from 'vue-i18n'

import en from '@shared/i18n/locales/en'
import es from '@shared/i18n/locales/es'
import fr from '@shared/i18n/locales/fr'

import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'

export const supportedLocales = [enLocale.name, esLocale.name, frLocale.name]

const appLanguage = () => {
  // really supported
  const appSupportedLocales = [enLocale.name]

  const navigatorLanguage = navigator.language?.split('-')[0]

  return appSupportedLocales.includes(navigatorLanguage)
    ? navigatorLanguage
    : enLocale.name
}

// eslint-disable-next-line
export const createLocale = (en: Record<string, any>, fr = {}, es = {}) => {
  const messages = {
    [enLocale.name]: {
      el: enLocale.el,
      ...en,
    },
    [frLocale.name]: {
      el: frLocale.el,
      ...fr,
    },
    [esLocale.name]: {
      el: esLocale.el,
      ...es,
    },
  }

  return createI18n({
    legacy: false,
    locale: appLanguage(),
    fallbackLocale: enLocale.name,
    warnHtmlInMessage: 'off',
    globalInjection: true,
    // silentTranslationWarn: true,
    silentFallbackWarn: true,
    messages,
    fallbackWarn: false,
  })
}

export default createI18n({
  legacy: false,
  locale: appLanguage(),
  fallbackLocale: enLocale.name,
  warnHtmlInMessage: false,
  globalInjection: true,
  messages: {
    en,
    es,
    fr,
  },
})
